<div class="card">
  <div class="card-header flex justify-between items-center">
    <h4><strong>AWS estimated bill summary</strong></h4>
    <p>Total charges and payment information</p>
  </div>

  <div class="card-body">
    <div class="summary">
      <div class="row">
        <div class="left">
          <p><strong>Account ID:</strong></p>
          <h5><strong>{{ account }}</strong></h5>
        </div>
        <div class="vertical-line"></div>
        <div class="right">
          <p><strong>Billing period</strong></p>
          <h5><strong>{{ formattedMonthYear }}</strong></h5>
        </div>
      </div>

      <div class="row">
        <div class="left">
          <p><strong>Service provider</strong></p>
          <h5><strong>Amazon Web Services, Inc. - MarketPlace</strong></h5>
        </div>
        <div class="vertical-line"></div>
        <div class="right">
          <p>Total in USD</p>
          <h5><strong>USD {{ summary?.total_market_place_cost ?? 0 | number: '1.2-2' }}</strong></h5>
        </div>
      </div>

      <div class="row">
        <div class="left">
          <p><strong>Service provider</strong></p>
          <h5><strong>Amazon Web Services India Private Limited</strong></h5>
        </div>
        <div class="vertical-line"></div>
        <div class="right">
          <p>Total in USD</p>
          <h5><strong>USD {{ summary?.total_aws_cost ?? 0 | number: '1.2-2' }}</strong></h5>
        </div>
      </div>

      <div class="row full-row grand-total">
        <h3><strong>Estimated grand total:
            <span class="amount">USD {{ summary?.total_final_cost ?? 0 | number: '1.2-2' }}</span>
          </strong></h3>
      </div>
    </div>
  </div>
</div>

<div class="card">
  <div class="card-header flex justify-between items-center">
    <h4><strong>Highest estimated cost by service provider</strong></h4>
    <p>Viewing Amazon Web Services, Inc. - MarketPlace</p>
  </div>

<div class="card-body">
  <div class="summary">
    <div class="row">
      <div class="left">
        <div class="flex-jc">
          <div class="item">
            <p class="mb-1"><strong>Highest service spend</strong></p>
            <h5>
              <strong>
                USD {{ highestspend?.highest_service_spend?.cost ?? 0 | number: '1.2-2' }}
              </strong>
            </h5>
          </div>
          <div class="item">
            <p class="mb-1"><strong>Trend compared to prior month</strong></p>
            <h5>
              <strong
                [ngClass]="
                  highestspend?.highest_service_spend?.trend_vs_prior_month > 0 
                    ? 'trend-up' 
                    : 'trend-down'
                "
              >
                {{ highestspend?.highest_service_spend?.trend_vs_prior_month ?? 0 }}%
              </strong>
            </h5>
          </div>
        </div>

        <div class="item pt-4">
          <p class="mb-0"><strong>Service name</strong></p>
          {{ highestspend?.highest_service_spend?.service ?? '-' }}
        </div>
      </div>

      <div class="vertical-line"></div>

      <div class="right">
        <div class="flex-jc">
          <div class="item">
            <p class="mb-1"><strong>Highest AWS Region spend</strong></p>
            <h5>
              <strong>
                USD {{ highestspend?.highest_region_spend?.cost ?? 0 | number: '1.2-2' }}
              </strong>
            </h5>
          </div>

          <div class="item">
            <p class="mb-1"><strong>Trend compared to prior month</strong></p>
            <h5>
              <strong
                [ngClass]="
                  highestspend?.highest_region_spend?.trend_vs_prior_month > 0 
                    ? 'trend-up' 
                    : 'trend-down'
                "
              >
                {{ highestspend?.highest_region_spend?.trend_vs_prior_month ?? 0 }}%
              </strong>
            </h5>
          </div>
        </div>

        <div class="item pt-4">
          <p class="mb-0"><strong>Region name</strong></p>
          {{ highestspend?.highest_region_spend?.region ?? '-' }}
        </div>
      </div>
    </div>
  </div>
</div>

</div>